import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Slider from "react-slick";
import {
  EXPLORE_COURSES_PATH,
  navigateFromDashboardSliderBanner,
} from "../../../custom_utilities/dashboardBannerNavigation";
import images from "../../../utilities/images/images";
import "./ExploreCoursesBannerCarousel.css";

const ExploreCoursesBannerCarousel = ({ banners = [], returnTo = EXPLORE_COURSES_PATH }) => {
  const history = useHistory();
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  if (!banners.length) return null;

  const hasMultipleBanners = banners.length > 1;

  const settings = {
    dots: false,
    infinite: hasMultipleBanners,
    autoplay: hasMultipleBanners,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: true,
    beforeChange: (_current, next) => setActiveIndex(next),
  };

  const goToSlide = (index) => {
    sliderRef.current?.slickGoTo(index);
    setActiveIndex(index);
  };

  return (
    <section className="explore-courses-banner" aria-label="Featured offers">
      <div className="explore-courses-banner__slider">
        <Slider ref={sliderRef} {...settings}>
          {banners.map((banner, index) => (
            <div key={banner?.value ?? banner?.id ?? index} className="explore-courses-banner__slide">
              <button
                type="button"
                className="explore-courses-banner__image-btn"
                onClick={() => navigateFromDashboardSliderBanner(history, banner, returnTo)}
                aria-label={banner?.title || `Featured offer ${index + 1}`}
              >
                <img
                  src={banner.img}
                  alt=""
                  className="explore-courses-banner__image"
                />
              </button>
            </div>
          ))}
        </Slider>
      </div>

      {hasMultipleBanners ? (
        <ul className="explore-courses-banner__dots" aria-label="Banner pagination">
          {banners.map((banner, index) => {
            const isActive = index === activeIndex;
            return (
              <li key={banner?.value ?? banner?.id ?? index}>
                <button
                  type="button"
                  className="explore-courses-banner__dot"
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to banner ${index + 1}`}
                  aria-current={isActive ? "true" : undefined}
                >
                  <img
                    src={isActive ? images.banner_dot_active : images.banner_dot_inactive}
                    alt=""
                    className="explore-courses-banner__dot-icon"
                    aria-hidden="true"
                  />
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </section>
  );
};

export default ExploreCoursesBannerCarousel;
